import { render } from "./EnviarDocumentos.vue?vue&type=template&id=3d85303e&scoped=true"
import script from "./EnviarDocumentos.vue?vue&type=script&lang=js"
export * from "./EnviarDocumentos.vue?vue&type=script&lang=js"

import "./EnviarDocumentos.vue?vue&type=style&index=0&id=3d85303e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d85303e"]])

export default __exports__